
















import Vue from 'vue'
import { Frame, store } from '@/store';
export default Vue.extend({
  props: {
    type: { required: true, type: String },
    module: { type: String },
    frame: {},
  },
  computed: {
    currentFrame(): Frame {
      return (this.frame as Frame) || store.currentFrame
    },
  },
})
